import { IKImage } from "imagekitio-next";
import React from "react";

type SmallCardThumbnail = {
  imageName: string;
  alt: string;
  className: string;
  key: string;
};

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const SmallCardThumbnailUrlWidth = 400;
const SmallCardThumbnailUrlHeight = 300;

const SmallCardThumbnail = (props: SmallCardThumbnail) => {
  return (
    <IKImage
      key={props?.key}
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      width={SmallCardThumbnailUrlWidth}
      height={SmallCardThumbnailUrlHeight}
      alt={props?.alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className={`${props.className}`}
      style={{
        maxWidth: "100%",
        height: "auto",
      }}
    />
  );
};

export default SmallCardThumbnail;
